import { useContext, useEffect } from "react"
import { ThemeContext } from "../../contexts/ThemeContext"

export default function Analytics() {

    const { setTitle } = useContext(ThemeContext)
    useEffect(() => {
        setTitle('Stardeas Analytics')
    }, [setTitle])


    return (
        <>
         <h1>Nearchat Analytics Page</h1>

        </>
    )
}